module.exports = __webpack_public_path__ + "media/images/dividend/ill-beach-mobile-17fbec959d77c63478903b5381a296ef.png";